$.advertising = $.advertising || {};
$.advertising.root =
{
    openMySettings: function (url) {
        var width = 900;
        var height = 500;

        // Set the docoment domain to shared domain to allow my settings window which is from a different subdomain work properly.
        var segments = document.domain.split('.');
        if (segments.length >= 3) {
            document.domain = segments.slice(-3).join('.');
        }

        if (typeof (ShowModal) != 'undefined') {
            ShowModal(url, width, height, true, false);
        }
        else {
            var iEargs = "dialogWidth=" + width + "px;dialogHeight=" + height + "px;scroll=no;status=no;help:no;toolbar:no;";

            //while these browsers support modal dialog, they have issues such as double chars and non functioning confirm dialog
            var agent = navigator.userAgent.toLowerCase();
            var inCompleteSupport = (agent.indexOf("safari") > -1) || (agent.indexOf("trident/6.0") > -1);

            if ((window.showModalDialog) && (!inCompleteSupport)) {
                var vResult = window.showModalDialog(url, window, iEargs);
                if (vResult) window.location.reload(); //IE..
            }
            else	//FireFox etc. support			
            {
                window.popup = window.open(url, "popup", "height=" + height + ",width=" + width + ",dialog=yes,modal=yes,scrollbars=no");
            }
        }

        return false;
    },

    //Help launch script    
    launchHelp: function (baseUrl, project, market, hostedUrl, querytype, query, resize, format, cu, puid, filter, target) {
        var projectId = 3;
        if( project.toLowerCase().indexOf('yahoo') >= 0){
			projectId = 4;
		}
        var targetUrl = baseUrl + '/#apex/' + projectId + '/' + market + '/' + query + '/-1/' + market;
        var winref = window.open(targetUrl, '_apexPlatformHelp'); //Force to open in new window
        if (winref != null && typeof winref == 'object') winref.focus(); //no hidden window
    },

    launchHelpFromAnswerBar: function (keyword) {
        var retval = false;
        if ((typeof ab_glb != 'undefined' && ab_glb && ab_glb.Version) && ($(".railhelp_bar").length > 0) && $(".railhelp_bar").is(":visible")) {
            HelpController.OpenHelpTopic(keyword);
            RailHelpController.SetABHelpIcon();
            retval = true;
        }
        return retval;
    },
    //bind Click Events for NavItems of Logout/Settings options
    bindNavItemClickEvents: function () {
        //activate User menu hover
        var mySettingsLink;
        $(".nav-item.user div, .nav-item.user span, .nav-user-actions, #utility li.user span, #utility li.user a").click(function (event) {
            event.stopPropagation();
            mySettingsLink = $(this);
            $(".nav-user-actions")
            .stop(true, true)
            .slideDown(400);
        });
     
        $(document).click(function () {   
            if (mySettingsLink != null) {
                $(".nav-user-actions")
                .stop(true, true)
                .delay(600)
                .slideUp(200);
                mySettingsLink = undefined;
            }
        });
    }
};

$(function ()
{
    if($('a.helpWindowLink').length) {
        $('a.helpWindowLink').live("click", function () {
            var helpModel = $(this).data('options');
            var market = $(this).data('market');

            $.advertising.root.launchHelp(helpModel.BaseHelpUrl, helpModel.ProjectName, market, '', helpModel.QueryType, helpModel.QueryValue, true, 'b1', '', '', '');
        });
    }
    if($('a.header-mysettings').length) {
        $('a.header-mysettings').click(function() {
            $.advertising.root.openMySettings($(this).data("url"));
        });        
    }
    $.advertising.root.bindNavItemClickEvents();
});



